import React from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import "video-react/dist/video-react.css";

import moment from "moment";
import { Session } from "bc-react-session";
import {
  Player,
  ForwardControl,
  ReplayControl,
  ControlBar,
  PlaybackRateMenuButton,
} from "video-react";

import VideoStatus from "../../Common/VideoStatus";
import Fined24Alert from "../../Common/Fined24Alert";
import SnapButton from "../../Utils/SnapButton";

import {
  Card,
  Empty,
  Drawer,
  message,
  Modal,
  Cascader,
  Spin,
  Row,
  Col,
  Input,
  Button,
  Descriptions,
} from "antd";
import { useState } from "react";
import SelectAjax from "../../Utils/SelectAjax";
import Form15 from "../../FineForms/Form15";
import Form16 from "../../FineForms/Form16";
import Form2 from "../../FineForms/Form2";
import { useEffect } from "react";
import Axios from "../../Axios";

const { payload } = Session.get();
const DATE_FORMAT = "DD/MM/YYYY hh:mm a";

const AuthorityForm = ({ video, closeVideo, onSuccess, visible }) => {
  const finishForm = (message, id) => {
    Modal.success({
      maskClosable: false,
      onOk: () => {
        onSuccess()
        closeVideo();
      },
      content: message || "Error al generar atención contacte con soporte",
    });
  };

  const { authority_id } = video;
  if (authority_id == 15) {
    return <Form15 onSuccess={finishForm}  visible={visible} pid={video.id} />;
  }

  if (authority_id == 16) {
    return <Form16 onSuccess={finishForm} visible={visible} pid={video.id} />;
  }

  return <Form2 onSuccess={finishForm} visible={visible} pid={video.id} />;
};

export const DrawerShow = ({ visible, closeVideo, videoId }) => {
  const [showForm, setShowForm] = useState(false);
  const [snapLoading, setSnapLoading] = useState(false);
  const [geocoding, setGeocoing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [video, setVideo] = useState(null);

  const fetchVideo = async (isFirst) => {
    if (isFirst) {
      setLoading(true);
    }
    try {
      const {
        data: { data },
      } = await Axios.get("/videos/" + videoId);
      setVideo(data);
    } catch (error) {
      message.warning("Error obteniendo video");
    } finally {
      setLoading(false);
    }
  };

  const updateField = async (field, value, succesMessage) => {
    const { data } = await Axios.patch("/videos/" + video.id, {
      [field]: value,
    });

    fetchVideo();
    message.success("Actualizado con éxito");
  };

  const fetchOptionsCategories = async () => {
    const { data } = await Axios.get("/utils/enabled-categories/children");
    setOptions(data.data);
  };

  const deleteImage = async (snapId) => {
    setSnapLoading(true);

    const { data } = await Axios.delete("/videos/delete-snap/" + snapId);

    setSnapLoading(false);

    if (data.success) {
      message.success(data.message);
      fetchVideo();
    } else {
      message.error(data.message);
    }
  };

  const sendModeration = async () => {
    const { data } = await Axios.patch("/videos/" + video.id, {
      request_moderation: 1,
    });

    if (data.success) {
      message.success(data.message);
      closeVideo();
    } else {
      message.error(data.message);
    }
  };

  const destroyVideo = async () => {
    try {
      setLoading(true)
       const { data } = await Axios.delete(`/videos/${video.id}/destroy-child`)

       message.success('Video eliminado');
       closeVideo();
      
    } catch (error) {
        message.error(error.message);
    } finally {
      setLoading(false)
    }
  }

  const onChangeIncident = (value) => {
    if (value.length === 2) {
      updateField("infringement_type_id", value[1]);
    }
  };

  const onCloseDrawer = ()=>{
    setVideo(null)
    closeVideo();
  }

  useEffect(() => {
    fetchOptionsCategories();
    if(videoId) {
    fetchVideo(true);
    }

  }, [videoId]);

  return (
    <Drawer
     destroyOnClose
      bodyStyle={{ padding: 5 }}
      title={"Video #" + video?.id}
      placement="right"
      maskClosable={false}
      closable={true}
      width={window.screen.width >= 768 ? "86%" : "100%"}
      height="100vh"
      onClose={onCloseDrawer}
      visible={visible}
      footer={
        <div
          style={{
            textAlign: "right",
          }}
        >
          <Button style={{ marginRight: 8 }}>Cancelar</Button>
          <Button
            type="primary"
            disabled={loading}
            loading={geocoding || loading}
            onClick={() => setShowForm(true)}
          >
            Atender ahora
          </Button>
        </div>
      }
    >
      {video ? (
        <Spin spinning={geocoding}>
          <Row>
            <Col xs={24} md={10}>
              <Player
                crossOrigin="anonymous"
                autoPlay={false}
                fluid={false}
                width={"100%"}
                height={500}
                playsInline
                poster={video.cover_url_cdn}
                src={video.video_url_cdn}
              >
                <ControlBar autoHide={false}>
                  <ReplayControl seconds={5} order={6.1} />
                  <ForwardControl seconds={5} order={6.2} />
                  <PlaybackRateMenuButton
                    rates={[3, 2, 1, 1.5, 0.5, 0.1]}
                    order={6.3}
                  />

                  <SnapButton
                    onCapturing={() => setSnapLoading(true)}
                    onSuccess={(data) => {
                      setSnapLoading(false);
                      fetchVideo();
                    }}
                    id={video.id}
                    order={7}
                  />
                </ControlBar>
              </Player>

              <Fined24Alert videoId={video.id} license={video.vehicle_plate} />

              <iframe
                src={
                  "https://maps.google.com/maps?q=" +
                  video.lat_video +
                  "," +
                  video.lng_video +
                  "&z=15&output=embed"
                }
                width="100%"
                height="450"
                style={{ width: "100wh" }}
                frameBorder="0"
              />

            {showForm && <Drawer
               destroyOnClose
                visible={showForm}
                title="Atender video"
                width={
                  window.innerWidth >= 768
                    ? window.innerWidth / 2 + 250
                    : "100%"
                }
                closable={true}
                maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.74)" }}
                onClose={()=>setShowForm(false)}
              >
                <AuthorityForm video={video} visible={showForm} closeVideo={closeVideo} onSuccess={()=>setShowForm(false)} />
              </Drawer>}
            </Col>

            <Col md={14}>
              <div style={{ padding: "10px 20px" }}>
                <Row gutter={16}>
                  <Col xs={24} md={8} span={8}>
                    <Card title="Placa" bordered={false}>
                      <Input
                        onBlur={(e) => {
                          const value = e.target.value;
                          const platePattern =
                            /^([A-Z]{3}\d{4}|[A-Z]{2}\d{3}[A-Z])$/i;

                          if (!value) {
                            message.error("La placa es obligatoria.");
                          } else if (!platePattern.test(value)) {
                            message.error(
                              "La placa debe tener formato automovil o moto."
                            );
                          } else {
                            updateField("vehicle_plate", value);
                          }
                        }}
                        defaultValue={video.vehicle_plate}
                      />
                    </Card>
                  </Col>
                  <Col xs={24} md={8} span={8}>
                    <Card title="Estado" bordered={false}>
                      <VideoStatus
                        status={video.status}
                        statusName={video.status_name}
                      />
                    </Card>
                  </Col>
                  <Col xs={24} md={8} span={8}>
                    
                      <Card title="Moderar" bordered={false}>
                       {payload.role == "admin" ? ( <Button onClick={sendModeration}>
                          Moderar
                        </Button>  ) : null}

                        {video.parent_id && <Button  type="primary" ghost style={{marginLeft: 5}} onClick={destroyVideo}>
                          Eliminar
                        </Button>}
                      </Card>
                  
                  </Col>
                </Row>

                <Descriptions bordered column={{ xs: 1, sm: 1 }}>
                  <Descriptions.Item label="Inspector">
                    {video.inspector_name ? video.inspector_name : "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Fecha Grabación">
                    {moment(video.device_creation_date).format(DATE_FORMAT)}
                  </Descriptions.Item>
                  <Descriptions.Item label="Fecha de Subida">
                    {moment(video.created_at).format(DATE_FORMAT)}
                  </Descriptions.Item>
                  <Descriptions.Item label="Distrito/Lugar">
                    <SelectAjax
                      label={"name"}
                      onSelect={(value) =>
                        updateField(
                          "municipality_id",
                          value,
                          "Municipalidad actualizada"
                        )
                      }
                      style={{ width: "100%" }}
                      value={video.municipality_id}
                      url={"/utils/enabled-places"}
                      placeholder="Asignar Municipalidad"
                    />
                  </Descriptions.Item>
                  <Descriptions.Item label="Tipo de incidente">
                    <Cascader
                      defaultValue={[
                        video.infringement_type_id_parent,
                        video.infringement_type_id,
                      ]}
                      fieldNames={{
                        label: "name",
                        value: "id",
                        children: "childs",
                      }}
                      options={options}
                      style={{ width: "100%" }}
                      onChange={onChangeIncident}
                      placeholder="Selecciona"
                    />
                  </Descriptions.Item>

                  <Descriptions.Item label="Dirección">
                    <Input
                      defaultValue={video.address}
                      onBlur={(e) => updateField("address", e.target.value)}
                    />
                  </Descriptions.Item>
                  <Descriptions.Item label="GPS">
                    <a
                      target="blank"
                      rel="noreferrer"
                      href={
                        "https://www.google.com/maps/search/?api=1&query=" +
                        video.lat_video +
                        "," +
                        video.lng_video
                      }
                    >
                      {video.lat_video},{video.lng_video}
                    </a>
                  </Descriptions.Item>

                  <Descriptions.Item label="Subido desde">
                    {(video.upload_origin === "camera"
                      ? "Cámara"
                      : video.upload_origin === "gallery"
                      ? "Galería"
                      : video.upload_origin) +
                      " de " +
                      video.upload_from}
                  </Descriptions.Item>

                  {video.comments && (
                    <Descriptions.Item label="Comentarios">
                      {video.comments}
                    </Descriptions.Item>
                  )}

                  <Descriptions.Item label="Fotos">
                    <Spin spinning={snapLoading}>
                      {video.snaps && video.snaps.length > 0 ? (
                        <div style={{ display: "flex" }}>
                          {video.snaps.map((snap, key) => {
                            return (
                              <div key={key} className="img-snap">
                                <Button
                                  onClick={() => deleteImage(snap.id)}
                                  size="small"
                                  style={{ marginBottom: 5 }}
                                >
                                  Delete
                                </Button>{" "}
                                <img src={snap.url_cdn} />
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <Empty description={"No hay fotos"} />
                      )}
                    </Spin>
                  </Descriptions.Item>
                </Descriptions>
              </div>
            </Col>
          </Row>
        </Spin>
      ) : (
        <Spin />
      )}
    </Drawer>
  );
};
